import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { HandleLinkedResourceAction, HandleLinkedResourceType } from '../types/worksheet';

export type HandleLinkedResourceRequest = {
    action: HandleLinkedResourceAction;
    propertyId: string;
    resourceType: HandleLinkedResourceType;
    resourceId: string;
};

async function handleLinkedResource(workpaperId: string, calculationId: string, request: HandleLinkedResourceRequest): Promise<void> {
    await api.post(`/workpapers/${workpaperId}/calculation/${calculationId}/linked-resources`, request);
}

export function useHandleLinkedResource(
    worksheetId?: string,
    calculationId?: string | null
): UseMutationResult<void, AxiosError, HandleLinkedResourceRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();

    return useMutation((req: HandleLinkedResourceRequest) => handleLinkedResource(workpaperId, calculationId!, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['entries', worksheetId]);
            queryClient.invalidateQueries(['worksheets', worksheetId]);
        },
    });
}
